/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { object } from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import MarketPageHeader from '../../pages/markets/pages/market/header';
import AdvancesDeclinesWidget from '../../pages/markets/component/advances-declines';
import AllNewsSection from '../../collection-templates/AllNewsSection';
import ResearchReports from '../../pages/markets/component/research-reports';
import MarketsNews from '../../pages/markets/component/markets-news';
import MoreFromMarkets from '../../pages/markets/component/more-from-markets';
import TopSectors from '../../pages/markets/component/top-sectors';
import CalendarEvents from '../../pages/markets/component/calendar-events';
import FuturesGraphMobile from '../../pages/markets/component/futures-graph-mobile';
import IndianIndices from '../../pages/markets/component/indian-indices';
import SingleVideoWidget from '../../collection-templates/videos-list-collection/single-video-widget';
import SectoralIndices from '../../pages/markets/component/sectoral-indices';
import StockStatistics from '../../pages/markets/component/stock-statistics';
import AdWithPlaceholder from '../../molecules/ad-with-placeholder';
import CalculatorWidget from '../../molecules/calculator-widget';
import { QueryClient, QueryClientProvider } from 'react-query';
import InfiniteStoryWithHeading from '../../molecules/infinite-story-with-heading';
import SocialShareMarketsHorizontal from '../../pages/markets/component/social-share-for-markets/social-share-markets-horizontal';
import { WithLazy } from '@quintype/components';
import MailmodoNewsLetter from '../../molecules/newsletter/mailmodo-news-letter';
import { isMobile } from 'react-device-detect';

import './markets-full.m.css';
import LiveTvWidget from '../../collection-templates/videos-list-collection/live-tv-widget';

const MarketPageBase = (props) => {
  const [news, setNews] = useState({});
  const [marketNews, setMarketNews] = useState({});
  const queryClient = new QueryClient();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getAllNews = async () => {
      const response = await fetch('/api/v1/collections/all-news-module');
      const data = await response;
      const dataInJson = await data.json();

      setNews(dataInJson);
    };
    getAllNews();
  }, []);

  useEffect(() => {
    const getMarketNews = async () => {
      setIsLoading(true);
      const response = await fetch('/api/v1/collections/markets');
      const data = await response;
      const dataInJson = await data.json();
      setMarketNews(dataInJson);
      setIsLoading(false);
    };
    getMarketNews();
  }, []);

  if (props.data.query) {
    return <InfiniteStoryWithHeading {...props} />;
  }
  return (
    <QueryClientProvider client={queryClient}>
      <>
        <div styleName="background-container">
          <div styleName="market-page" className="container">
            <div styleName="first-fold-top">
              <div className="sidebar row-section">
                <MarketsNews newsData={marketNews} loadingStatus={isLoading} />
                <IndianIndices />
              </div>
            </div>
          </div>
        </div>

        <div styleName="market-page" className="container">
          <div styleName="first-fold" className="mobile-only">
            <div className="sidebar row-section">
              <IndianIndices />
              <MarketsNews newsData={marketNews} loadingStatus={isLoading} />
            </div>
          </div>

          <div styleName="second-content-fold">
            <div className="sidebar row-section">
              <ResearchReports />
            </div>

            <div className="sidebar row-section">
              <StockStatistics />

              <div styleName="futures-subscriptions-container">
              <FuturesGraphMobile flag="homepage" />
              </div>
            </div>

            <div className="sidebar row-section" id="more-from-markets">
              <MoreFromMarkets newsData={marketNews} />
              <AdvancesDeclinesWidget />
            </div>
          </div>
        </div>

        <div styleName="background-container">
          <div styleName="market-page" className="container">
            <div styleName="second-content-fold">
              <div className="sidebar row-section">
                <WithLazy>{() => <SectoralIndices />}</WithLazy>
                <WithLazy>
                  {() => (
                    <div styleName="video-social-container" className="video-social-widgets">
                      <LiveTvWidget />
                    </div>
                  )}
                </WithLazy>
              </div>
            </div>
          </div>
        </div>

        <div styleName="market-page" className="container">
          <WithLazy>
            {() => (
              <div styleName="first-fold">
                <div className="sidebar row-section">
                  <TopSectors />
                  <CalendarEvents />
                </div>
              </div>
            )}
          </WithLazy>
        </div>
      </>
    </QueryClientProvider>
  );
};

MarketPageBase.propTypes = {
  config: object,
  data: object,
};

const mapStateToProps = (state) => ({
  config: get(state.qt, ['config'], {}),
});

const MarketsFull = connect(mapStateToProps, {})(MarketPageBase);

export default MarketsFull;
